<template>
  <div>
    <div v-if="!fileSelect" class="file-card">
      <div class="file-card--image file-search-tooltip" :data-tooltip="fileUrls[file.id] || ''" @mouseenter="onFileHover(file)">
        <img v-if="thumbnail_url" :src="thumbnail_url" alt=""/>
        <img v-else src="~@/assets/images/thumbnail-placeholder.png" />
      </div>
      <div
        v-if="hasAnyFileAction"
        class="file-card-action"
      >
        <img
        v-if="showMoreOptionsButton"
          src="~@/assets/images/icons/more-icon.svg"
          class="file-card-action--btn"
          alt=""
        />
        <div class="file-card-options">
          <div
            v-if="disableDownload()"
            class="file-card-option"
            @click="disable"
            :data-enable="disableDownload()"
          >
            <span :class="{ 'grey-text' : disabledisableDownloadButton }">Disable Download</span>
          </div>
          <div
            v-if="enableDownload()"
            class="file-card-option"
            @click="enable"
            :data-enable="enableDownload()"
          >
            <span :class="{ 'grey-text' : disableEnableDownloadButton }">Enable Download</span>
          </div>
          <!-- <div
            v-if="canCheckin"
            class="file-card-option"
            @click="checkin"
            :data-enable="canCheckin"
          >
            <span :class="{ 'grey-text' : disableCheckinButton }"> Checkin </span>
          </div>
          <div
            v-else-if="canCheckout"
            class="file-card-option"
            @click="checkout"
            :data-enable="canCheckout"
          >
            <span :class="{ 'grey-text' : disableCheckoutButton }">Checkout</span>
          </div>
          <div
        v-if="canUndoCheckout"
          class="file-card-option"
          @click="undoCheckout"
          :data-enable="canUndoCheckout"
        >
          <span :class="{ 'grey-text' : disableUndoCheckoutButton }">Undo Checkout</span>
        </div> -->
        <!-- <div>
            <div
              v-if="canLock"
              class="file-card-option"
              @click="lock"
              :data-enable="canLock"
            >
              <span :class="{ 'grey-text' : disableLockButton }">Lock</span>
            </div>
            <div
              v-else-if="canUnlock"
              class="file-card-option"
              @click="unLock"
              :data-enable="true"
            >
              <span :class="{ 'grey-text' : disableUnlockButton }">Unlock</span>
            </div>
          </div> -->
          <!-- <div v-if="showObseleteOption">
            <div
              class="file-card-option"
              @click="obselete"
              v-if="canObselete && !collaborator"
              :data-enable="canObselete"
            >
              <span :class="{ 'grey-text' : disableObseleteButton }">Obselete</span>
            </div>
            <div
              v-else-if="file.state === META_CONFIG.DOC_STATE_MAP.OBSOLETE"
              @click="nonObselete"
              class="file-card-option"
              :data-enable="!canObselete"
            >
              <span :class="{ 'grey-text' : disableNonObseleteButton }">Non Obselete</span>
            </div>
          </div> -->
        </div>
      </div>
      <div v-if="file?.inherited_from_doc_id" class="file-card-action">
        <img
          v-tooltip="InheritedIconTooltip"
          src="~@/assets/images/icons/inherit-icon.svg"
          class="file-card-action--btn"
          @click="openUpdateInheritedDocModal"
          alt=""
        />
      </div>
      <div class="p-2">
        <div class="v-center">
          <div
            class="weight-500 l elipsis-text"
            v-overflow-tooltip
            :class="isObselete ? 'red' : ''"
          >
            {{ updatedName ? updatedName : file.doc_name }}
          </div>
          <span v-if="isNew" class="new-tag ml-2">new</span>
        </div>
        <div class="mt-3 v-center">
          <img
            src="~@/assets/images/icons/material-symbols.svg"
            class="document-view-icons"
            alt="material-symbol"
          />
          <div class="weight-400 xs ml-1">Versions:</div>
          <div class="chip" :class="isObselete ? 'obsolete' : ''">
            {{
               file?.inherited_from_doc_id
    ? (file?.inherited_from_document?.associated_versions_aggregate?.aggregate?.count ?? 0) + 1
    : (file?.associated_versions_aggregate?.aggregate?.count != null
        ? file.associated_versions_aggregate.aggregate.count + 1
        : file?.version_no)
            }}
            Versions
          </div>
        </div>
        <div class="mt-3 v-center">
        <div class="weight-400 xs ml-1">PLM Id:</div>
        <div class="chip">
            {{ file?.plm_document_id ?? '--' }} {{ `(version: ${file?.plm_version_no ?? '--'})` }}
        </div>
        </div>
        <div class="mt-3 v-center">
          <img
            src="~@/assets/images/icons/state-icon.svg"
            class="document-view-icons"
            alt="material-symbol"
            width="15"
          />
          <div class="weight-400 xs ml-1">State:</div>
          <div class="chip" :class="isObselete ? 'obsolete' : ''">
            {{
              META_CONFIG.DOC_STATE[
                file?.inherited_from_doc_id
                  ? file?.inherited_from_document?.state
                  : file.state
              ]
            }}
            {{ findwhocheckout ? 'by '+findwhocheckout : null}}
          </div>
        </div>
        <div v-if="parentFolder" class="mt-3 v-center flex-end file-card-footer">
          <div v-if="showCheckinBtn"
          @click="executeManualDocumentAction('checkin')" v-tooltip="'CheckIn'"  class="icon-btn">
            <img
           src="~@/assets/images/icons/checkIn-file.svg" alt="CheckIn"
          />
        </div>
          <div v-if="showCheckoutBtn" v-tooltip="'Checkout'" class="icon-btn"
            :class="{ 'is-disabled': !(wfAssignees(file) || user.tenantLevelRole === 'ADMIN') && file?.ongoing_lifecycle_workflow_id }"
            @click="executeManualDocumentAction('checkout')">
            <img
          src="~@/assets/images/icons/checkout-file.svg" alt="Checkout"
          />
          </div>
          <div v-if="showUndoCheckoutBtn" class="icon-btn"
           @click="executeManualDocumentAction('undo-checkout')"  v-tooltip="'Undo checkout'">
            <img
              src="~@/assets/images/icons/undo-checkout.svg" alt="undo-checkout"
              />
          </div>
          <div
            v-if="showStatusChangeIcon && !hasOngoingLifecycleWorkflow"
            @click="!isExternalCollaborator && handleStatusChange(file)"
            class="icon-btn"
            :class="{ 'is-disabled': isExternalCollaborator || (file.state === META_CONFIG.DOC_STATE_MAP.CHECKOUT || file.state === META_CONFIG.DOC_STATE_MAP.RELEASE) }"
            v-tooltip="'Status Change'"
          >
            <img
              src="~@/assets/images/icons/status-change.svg"
              alt="Status Change"
            />
        </div>
          <div
            v-else-if="showStatusChangeIcon && hasOngoingLifecycleWorkflow && (!isExternalCollaborator || wfAssignees(file))"
            @click="openWFInstanceModal(file)"
            class="icon-btn"
            :class="{'is-disabled': !canAccessOngoingWorkflow(file)}"
            v-tooltip="'Ongoing Workflow'"
          >
            <img
              src="~@/assets/images/icons/workflows.svg"
              alt="Ongoing Workflow"
            />
          </div>
          <upload-document
            :folder="file"
            :open="false"
            :parentFolder="parentFolder"
            :is_revision="true"
            @uploaded="uploadedRevision"
            v-if="canUpload"
          >
            <div
              v-if="showUploadRevisionButton"
              class="icon-btn"
              v-tooltip="'Upload revision'"
            >
              <img src="~@/assets/images/icons/upload-icon.svg" alt="" />
            </div>
          </upload-document>
          <div
            v-if="checkShareable"
            @click="shareDocs = true"
            class="icon-btn-document"
            v-tooltip="'Share Document'"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 -960 960 960"
              width="22"
            >
              <path
                d="M720-80q-50 0-85-35t-35-85q0-7 1-14.5t3-13.5L322-392q-17 15-38 23.5t-44 8.5q-50 0-85-35t-35-85q0-50 35-85t85-35q23 0 44 8.5t38 23.5l282-164q-2-6-3-13.5t-1-14.5q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35q-23 0-44-8.5T638-672L356-508q2 6 3 13.5t1 14.5q0 7-1 14.5t-3 13.5l282 164q17-15 38-23.5t44-8.5q50 0 85 35t35 85q0 50-35 85t-85 35Zm0-640q17 0 28.5-11.5T760-760q0-17-11.5-28.5T720-800q-17 0-28.5 11.5T680-760q0 17 11.5 28.5T720-720ZM240-440q17 0 28.5-11.5T280-480q0-17-11.5-28.5T240-520q-17 0-28.5 11.5T200-480q0 17 11.5 28.5T240-440Zm480 280q17 0 28.5-11.5T760-200q0-17-11.5-28.5T720-240q-17 0-28.5 11.5T680-200q0 17 11.5 28.5T720-160Zm0-600ZM240-480Zm480 280Z"
              />
            </svg>
            <!-- <img src="~@/assets/images/icons/photo-icon.svg" alt="" /> -->
          </div>
          <div
            v-if="canViewDetail"
            @click="openDetail"
            class="icon-btn"
            v-tooltip="'View Detail'"
          >
            <img src="~@/assets/images/icons/photo-icon.svg" alt="" />
          </div>
          <div v-if="showDeleteButton">
            <div
              v-if="canDelete && !collaborator"
              @click="tryDeleteFile"
              class="icon-btn"
              v-tooltip="'Delete'"
            >
              <img src="~@/assets/images/delete-gray-icon.svg" alt="" />
            </div>
          </div>
          <div>
            <div
              class="icon-btn"
              @click="editDocModal = true"
              v-if="canRename && !isExternalCollaborator"
              v-tooltip="'Rename'"
            >
              <img src="~@/assets/images/edit-icon.svg" alt="" />
            </div>
          </div>
          <spinner v-if="isDownloading"></spinner>
          <div v-else-if="viewOnly"></div>
          <div v-else-if="!collaborator" class="icon-btn download-doc-icon" ref="downloadBox">
            <img
              src="~@/assets/images/icons/cloud-download.svg"
              class="document-view-icons"
              alt="material-symbol"
              @click="openDownLoadList"
              v-tooltip="'Download'"
            />
            <div
              class="download-doc-icon-list"
              v-if="openVersionList"
              @mouseleave="openVersionList = false"
            >
              <ul>
                <li
                  v-for="version in fileVersions"
                  :key="version.blob_key"
                  @click="downloadSelectedFile(version)"
                >
                  Version - {{ version.version_no }}
                </li>
              </ul>
            </div>
          </div>
          <div v-else-if="collaborator && !file.view_only " class="icon-btn download-doc-icon" ref="downloadBox">
            <img
              src="~@/assets/images/icons/cloud-download.svg"
              class="document-view-icons"
              alt="material-symbol"
              @click="openDownLoadList"
              v-tooltip="'Download'"
            />
            <div
              class="download-doc-icon-list"
              v-if="openVersionList"
              @mouseleave="openVersionList = false"
            >
              <ul>
                <li
                  v-for="version in fileVersions"
                  :key="version.blob_key"
                  @click="downloadSelectedFile(version)"
                >
                  Version - {{ version.version_no }}
                </li>
              </ul>
            </div>
          </div>
          <div class="icon-btn download-doc-icon" v-else-if="collaborator && file.view_only">
            <img v-tooltip="'Disabled Download'" src="~@/assets/images/disable_download.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="file-name-card" @click="$emit('file-selected', file)">
        <input
          type="checkbox"
          :checked="file.id === selectedFile?.id ? true : false"
        />
        <img src="~@/assets/images/icons/file-icon.svg" width="20px" alt="" />
        <span class="weight-500 l elipsis-text" v-overflow-tooltip>
          {{
            file?.inherited_from_doc_id
              ? file?.inherited_from_document?.doc_name
              : file.doc_name
          }}
        </span>
      </div>
    </div>
    <modal
      title="Edit Document"
      :open="editDocModal"
      @close="editDocModal = false"
    >
      <rename-dialog
        @cancel="editDocModal = false"
        @renamed="handleRename"
        :updated-name="updatedName"
        :file="file"
        :open="editDocModal"
        :image="thumbnail_url"
        v-if="editDocModal"
      />
    </modal>
    <modal
      title="Update Document"
      :open="updateInheritedDocModal"
      @close="updateInheritedDocModal = false"
      :closeOnOutsideClick="true"
    >
      <div class="p-5">
        Are you sure to update the document to latest ?
        <div class="flex-end mt-7">
          <button
            class="btn btn-cancel ml-3"
            @click="updateInheritedDocModal = false"
          >
            Cancel
          </button>
          <button class="btn ml-3 update-btn" @click="updateInheritedDoc">
            Update
          </button>
        </div>
      </div>
    </modal>
    <modal
      v-if="!collaborator"
      title="Share Documents"
      :closeOnOutsideClick="true"
      @close="shareDocs = false"
      :open="shareDocs"
    >
      <share-document
        v-if="shareDocs"
        :id="file.id"
        :versionId="2"
        item="document"
        @close="shareDocs = false"
      />
    </modal>
    <modal
      @close="cancelWfSelectionModal"
      :open="wfSelectionModal"
      :title="'Change Document Status'"
    >
      <div class="material-history-container">
        <div v-if="wfSelectionLoader.loader" class="fh fw center loader-conatainer">
          <loading-circle />
        </div>
        <wf-selection-lifecycle
          v-else
          :workflows="filteredWorkflowsData"
          :feature="{ name: 'documents', id: file.id, data: file}"
          :cancel="cancelWfSelectionModal"
          :emitChanges="handleLifecycleStarted"
          :wfModalLoaderController="wfModalLoaderController"
          :panelStyle="'flat'"
          :workflowLoading="wfSelectionLoader.skelton"
          :showManualStatusChange="showStatusChangeOptions"
        >
          <template
            #actions="{
              statusChangeMode
            }"
          >
            <div v-if="statusChangeMode === 'manual'" class="wf-status-action fh fw">
              <p class="wf-status-action__title">Target Status</p>
              <div class="wf-status-action__grid">
                <button
                  v-if="showManualCheckinStatusBtn"
                  type="button"
                  :class="[
                    'wf-status-action__btn',
                    { 'wf-status-action__btn--active': selectedManualAction === 'checkin' }
                  ]"
                  @click="setSelectedManualAction('checkin')"
                >
                  CHECKIN
                </button>
                <button
                  v-if="showManualCheckoutStatusBtn"
                  type="button"
                  :class="[
                    'wf-status-action__btn',
                    { 'wf-status-action__btn--active': selectedManualAction === 'checkout' }
                  ]"
                  @click="setSelectedManualAction('checkout')"
                >
                  CHECKOUT
                </button>
                <button
                  v-if="showManualLockStatusBtn"
                  type="button"
                  :class="[
                    'wf-status-action__btn',
                    { 'wf-status-action__btn--active': selectedManualAction === 'lock' }
                  ]"
                  @click="setSelectedManualAction('lock')"
                >
                  LOCK
                </button>
                <button
                  v-if="showManualUndoCheckoutStatusBtn"
                  type="button"
                  :class="[
                    'wf-status-action__btn',
                    { 'wf-status-action__btn--active': selectedManualAction === 'undo-checkout' }
                  ]"
                  @click="setSelectedManualAction('undo-checkout')"
                >
                  UNDO CHECKOUT
                </button>
                <button
                  v-if="showObsoleteStatusBtn"
                  type="button"
                  :class="[
                    'wf-status-action__btn',
                    { 'wf-status-action__btn--active': selectedManualAction === 'obsolete' }
                  ]"
                  @click="setSelectedManualAction('obsolete')"
                >
                  OBSOLETE
                </button>
                <button
                  v-if="showReleaseStatusBtn"
                  type="button"
                  :class="[
                    'wf-status-action__btn',
                    { 'wf-status-action__btn--active': selectedManualAction === 'release' }
                  ]"
                  @click="setSelectedManualAction('release')"
                >
                  RELEASE
                </button>
              </div>
              <div class="wf-status-action__footer gap-1">
                <button class="btn" @click="proceedWithManualStatusChange">Change</button>
              </div>
            </div>
          </template>
        </wf-selection-lifecycle>
      </div>
    </modal>
    <modal
      @close="workflowInstanceModal = false"
      :open="workflowInstanceModal"
      :title="'Update Document'"
    >
      <workflow-instance-edit-panel
        v-if="file.ongoing_lifecycle_workflow_id"
        ref="WorkflowDetailsPanel"
        :panel-style="'alternate'"
        :wfInstanceId="file.ongoing_lifecycle_workflow_id"
        :feature="META_CONFIG.CORE_FEATURES.DOCUMENTS"
        @workflowHistoryUpdated="handleWorkflowHistoryUpdate"
        @goBack="workflowInstanceModal = false"
        @finishWorkflow="finishWorkflow"
        @afterWFaction="afterWFAction"
        @workflowCancelled="workflowCancelled"
        :Status="file.state"
      />
    </modal>
  </div>
</template>

<script>
import {
  generateS3DownloadingUrlSingle,
  deleteDocument,
  setDocumentState,
  lifeCycleStatusUpdate,
  updateInheritedDocument,
  addComments,
  getAllAttachedDocs,
  SwitchDownload,
  SendNotificationsForReadingAndDownloadingDocs,
  getDocPath,
  getWfListBasedOnId
  // downloadDocument
} from '@/api'
import confirmationDialog from '@/plugins/confirmationDialog'
import Modal from '../common/modal.vue'
import ShareDocument from '../common/share.vue'
import UploadDocument from './uploadDocument.vue'
import RenameDialog from './renameDialog.vue'
import Spinner from '../common/spinner.vue'
import loadingCircle from '../common/loadingCircle.vue'
import wfSelectionLifecycle from '../workflows/wfSelectionLifecycle.vue'
import WorkflowInstanceEditPanel from '@/views/FORM/workflowInstanceEditPanel.vue'
import META_CONFIG from '@/config'
import { mapGetters } from 'vuex'
import { success, alert } from '@/plugins/notification'
export default {
  components: {
    UploadDocument,
    Spinner,
    Modal,
    ShareDocument,
    RenameDialog,
    loadingCircle,
    wfSelectionLifecycle,
    WorkflowInstanceEditPanel
  },
  name: 'fileCard',
  props: {
    thumbnail_url: {
      type: String,
      default: ''
    },
    fileSelect: {
      type: Boolean,
      default: false
    },
    selectedFile: {
      type: Object,
      default: () => ({})
    },
    file: {
      type: Object,
      default: () => ({})
    },
    parentFolder: {
      type: Object,
      default: () => ({})
    },
    isNew: {
      type: Boolean,
      default: false
    },
    searchKeyword: {
      type: String
    }
  },
  data: () => ({
    disableCheckinButton: false,
    disableCheckoutButton: false,
    disableUndoCheckoutButton: false,
    disableLockButton: false,
    disableUnlockButton: false,
    disableObseleteButton: false,
    disableNonObseleteButton: false,
    disabledisableDownloadButton: false,
    disableEnableDownloadButton: false,
    META_CONFIG,
    openVersionList: false,
    isDownloading: false,
    shareDocs: false,
    updateInheritedDocModal: false,
    editDocModal: false,
    wfSelectionModal: false,
    workflowInstanceModal: false,
    wfSelectionLoader: { loader: false, skelton: false },
    selectedManualAction: null,
    workflowsData: [],
    updatedName: '',
    attachedDocs: [],
    fileUrls: {}
  }),
  computed: {
    ...mapGetters(['isTenantAdmin', 'isOnProjectLevel', 'isProjectViewer', 'isTenantViewer', 'childTenantsList']),
    ...mapGetters(['user', 'getUserById', 'collaborator', 'isExternalCollaborator']),
    hasAnyFileAction () {
      return (
        this.disableDownload() ||
    this.enableDownload() ||
    this.canCheckin ||
    this.canCheckout ||
    this.canUndoCheckout ||
    this.canLock ||
    this.canUnlock ||
    (this.showObseleteOption &&
      ((this.canObselete && !this.collaborator) ||
        this.file.state === META_CONFIG.DOC_STATE_MAP.OBSOLETE))
      )
    },
    showMoreOptionsButton () {
      if (this.isOnProjectLevel) {
        return (this.user.projectLevelRole === 'ADMIN' ||
        this.user.projectLevelRole === 'EDITOR' ||
        this.user.projectLevelRole === 'COLLABORATOR' ||
        this.isExternalCollaborator)
      } else {
        return (
          this.user.tenantLevelRole === 'ADMIN' ||
        this.user.tenantLevelRole === 'EDITOR' ||
          this.user.tenantLevelRole === 'COLLABORATOR' ||
          this.isExternalCollaborator)
      }
    },
    filteredChildTenants () {
      return this.childTenantsList.filter((tenant) => ((tenant.status === 1 || tenant.status === 4) && tenant.target_tenant.status === 1))
    },
    findwhocheckout () {
      if (this.file.state !== META_CONFIG.DOC_STATE_MAP.CHECKOUT) {
        return false
      }
      if (this.file.checked_out_by === this.user.userId) {
        return 'You'
      } else {
        return this.getUserById(this.file.checked_out_by).associated_user?.first_name
      }
    },
    viewOnly () {
      // here this.isTenantViewer might come true  for ext colaborator , bcz isTenantViewer is showing the role of this user with his actual tenant, so for exr colabarotor this check will get failed
      if (this.collaborator) {
        return false
      } else if (this.isOnProjectLevel) {
        return this.isProjectViewer
      } else {
        return this.isTenantViewer
      }
    },
    isInheritedDocument () {
      return Boolean(this.file?.inherited_from_doc_id)
    },
    canUndoCheckout () {
      if (this.isInheritedDocument) {
        return false
      }
      if (this.file.ongoing_revision_form_id) {
        return false
      } else if (this.collaborator) {
        return (this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKOUT && this.file.checked_out_by === this.user.userId)
        // if the documnet is check out by someone else , then admin could be able to do  undo the checkout
      } else if (this.file.checked_out_by === this.user.userId) {
        return (
          this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKOUT
        )
      } else {
        return (this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKOUT && (this.user.tenantLevelRole === 'ADMIN' || this.user.projectLevelRole === 'ADMIN'))
      }
    },
    canCheckin () {
      if (this.isInheritedDocument) {
        return false
      }
      if (this.file.ongoing_revision_form_id) {
        return false
      } else if (this.collaborator) {
        return (
          this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKOUT && !this.file.view_only && this.file.checked_out_by === this.user.userId
        )
      } else {
        return (
          this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKOUT &&
         (this.file.checked_out_by === this.user.userId))
      }
    },
    checkShareable () {
      if (!this.filteredChildTenants.length) {
        return false
      }
      if (this.file.ongoing_revision_form_id) {
        return false
      } else if (this.isOnProjectLevel) {
        return (
          !this.collaborator &&
          this.file.state !== META_CONFIG.DOC_STATE_MAP.OBSOLETE &&
          this.user.projectLevelRole !== 'VIEWER' &&
          (!this.collaborator || !this.file.view_only)
        )
      } else {
        return (
          !this.collaborator &&
          this.file.state !== META_CONFIG.DOC_STATE_MAP.OBSOLETE &&
          this.user.tenantLevelRole !== 'VIEWER' &&
          (!this.collaborator || !this.file.view_only)
        )
      }
    },
    isObselete () {
      const state = this.file?.inherited_from_doc_id
        ? this.file?.inherited_from_document?.state
        : this.file.state
      return state === META_CONFIG.DOC_STATE_MAP.OBSOLETE
    },
    canCheckout () {
      if (this.isInheritedDocument) {
        return false
      }
      if (this.file.ongoing_revision_form_id) {
        return false
      } else if (this.collaborator) {
        return (
          this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKIN && !this.file.view_only
        )
      } else {
        return (
          this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKIN &&
         (this.file.checked_out_by === this.user.userId ||
          (
            this.user.tenantLevelRole === 'ADMIN' ||
            this.user.tenantLevelRole === 'COLLABORATOR' ||
            this.user.tenantLevelRole === 'EDITOR' ||
            this.user.projectLevelRole === 'EDITOR' ||
            this.isExternalCollaborator
          )
         ))
      }
    },
    isInheritedLatest () {
      if (!this.file.inherited_from_doc_id) {
        return false
      }
      if (this.file.inherited_from_document?.associated_versions?.length) {
        return (
          this.file.inherited_from_document?.associated_versions[
            this.file.inherited_from_document?.associated_versions?.length - 1
          ].id === this.file.inherited_from_doc_id
        )
      }
      if (
        this.file?.inherited_from_document?.main_version_document
          ?.associated_versions?.length
      ) {
        return (
          this.file?.inherited_from_document?.main_version_document
            ?.associated_versions[
            this.file?.inherited_from_document?.main_version_document
              ?.associated_versions?.length - 1
            ]?.id === this.file.inherited_from_doc_id
        )
      }
      return true
    },
    InheritedIconTooltip () {
      if (this.isInheritedLatest) {
        return 'Document is at the latest version'
      } else if (this.user.tenantLevelRole === 'VIEWER') {
        return 'Document is outdated'
      } else {
        return 'Document is outdated. Click the icon to update'
      }
    },
    canLock () {
      if (this.file.ongoing_revision_form_id) {
        return false
      } else {
        return (this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKIN && this.user.tenantLevelRole !== 'EDITOR' && !(this.collaborator || this.isExternalCollaborator))
      }
    },
    canUnlock () {
      return (this.file.state === META_CONFIG.DOC_STATE_MAP.LOCK && this.user.tenantLevelRole !== 'EDITOR' && !(this.collaborator || this.isExternalCollaborator))
    },
    canObselete () {
      if (this.file.ongoing_revision_form_id) {
        return false
      } else if (this.user.projectLevelRole === null) {
        return (
          this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKIN &&
          this.isTenantAdmin &&
          this.user.tenantLevelRole === 'ADMIN'
        )
      } else {
        return (
          this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKIN &&
          this.isTenantAdmin &&
          this.user.projectLevelRole === 'ADMIN'
        )
      }
    },
    canDelete () {
      if (this.file.ongoing_revision_form_id) {
        return false
      } else if (this.user.projectLevelRole === null) {
        return (
          (this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKIN ||
            (this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKOUT &&
              this.file.checked_out_by === this.user.userId)) &&
          this.user.tenantLevelRole === 'ADMIN'
        )
      } else {
        return (
          (this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKIN ||
            (this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKOUT &&
              this.file.checked_out_by === this.user.userId)) &&
          this.user.projectLevelRole === 'ADMIN'
        )
      }
    },
    canUpload () {
      if (this.isInheritedDocument) {
        return false
      }
      if (this.file.ongoing_revision_form_id) {
        return false
      } else {
        return (
          this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKIN ||
          (this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKOUT && this.file.checked_out_by === this.user.userId)
        )
      }
    },
    canRename () {
      if (this.file.ongoing_revision_form_id) {
        return false
      } else {
        return (
          (this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKOUT && this.file.checked_out_by === this.user.userId)
        )
      }
    },
    canViewDetail () {
      return true
    },
    hasOngoingLifecycleWorkflow () {
      return Boolean(this.file?.ongoing_lifecycle_workflow_id)
    },
    isCollaboratorUser () {
      return (
        this.collaborator ||
        this.user.tenantLevelRole === 'COLLABORATOR' ||
        this.user.projectLevelRole === 'COLLABORATOR'
      )
    },
    isEditorUser () {
      return !this.isCollaboratorUser &&
        (this.user.tenantLevelRole === 'EDITOR' || this.user.projectLevelRole === 'EDITOR' || this.isExternalCollaborator)
    },
    showStatusChangeIcon () {
      return this.showFileActionCard
    },
    isAdminStatusUser () {
      return (this.user.tenantLevelRole === 'ADMIN' || this.user.projectLevelRole === 'ADMIN')
    },
    canCheckinFromObsolete () {
      return (
        this.file.state === META_CONFIG.DOC_STATE_MAP.OBSOLETE &&
        this.isAdminStatusUser &&
        !this.collaborator
      )
    },
    canCheckinFromRelease () {
      const normalizedState = Number(this.file.state)
      return (
        normalizedState === META_CONFIG.DOC_STATE_MAP.RELEASE &&
        this.isAdminStatusUser
      )
    },
    canObsoleteFromLock () {
      return (
        this.file.state === META_CONFIG.DOC_STATE_MAP.LOCK &&
        this.isAdminStatusUser &&
        !this.collaborator &&
        !this.file.ongoing_revision_form_id
      )
    },
    canReleaseFromCheckin () {
      return (
        this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKIN &&
        this.isAdminStatusUser &&
        !this.collaborator &&
        !this.file.ongoing_revision_form_id
      )
    },
    canReleaseFromLock () {
      return (
        this.file.state === META_CONFIG.DOC_STATE_MAP.LOCK &&
        this.isAdminStatusUser &&
        !this.collaborator &&
        !this.file.ongoing_revision_form_id
      )
    },
    showCheckinBtn () {
      const normalizedState = Number(this.file.state)
      if (normalizedState === META_CONFIG.DOC_STATE_MAP.RELEASE) {
        return this.isTenantAdmin
      }
      return this.canCheckin || this.canCheckinFromObsolete
    },
    showCheckoutBtn () {
      return this.canCheckout
    },
    showLockStatusBtn () {
      return this.canLock && (this.user.tenantLevelRole === 'ADMIN' || this.user.tenantLevelRole === 'COLLABORATOR')
    },
    showManualCheckinStatusBtn () {
      if (this.isInheritedDocument) {
        return false
      }
      if (this.file.ongoing_revision_form_id) {
        return false
      }
      if (this.isCollaboratorUser) {
        if (this.file.view_only) {
          return false
        }
        return (
          (this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKOUT && this.file.checked_out_by === this.user.userId) ||
          this.file.state === META_CONFIG.DOC_STATE_MAP.LOCK
        )
      }
      return this.showCheckinBtn
    },
    showManualCheckoutStatusBtn () {
      if (this.isInheritedDocument) {
        return false
      }
      if (this.file.ongoing_revision_form_id) {
        return false
      }
      if (this.isCollaboratorUser) {
        return this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKIN && !this.file.view_only
      }
      return this.showCheckoutBtn
    },
    showManualLockStatusBtn () {
      if (this.file.ongoing_revision_form_id) {
        return false
      }
      if (this.isCollaboratorUser) {
        return this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKIN && !this.file.view_only
      }
      return this.showLockStatusBtn
    },
    showManualUndoCheckoutStatusBtn () {
      if (this.isInheritedDocument) {
        return false
      }
      if (this.file.ongoing_revision_form_id) {
        return false
      }
      if (this.isEditorUser) {
        return this.canUndoCheckout
      }
      return false
    },
    showUndoCheckoutBtn () {
      return this.canUndoCheckout
    },
    showObsoleteStatusBtn () {
      return (this.canObselete || this.canObsoleteFromLock) && !this.collaborator && this.user.tenantLevelRole === 'ADMIN'
    },
    showReleaseStatusBtn () {
      return (this.canReleaseFromCheckin || this.canReleaseFromLock) && !this.collaborator && this.user.tenantLevelRole === 'ADMIN'
    },
    showFileActionCard () {
      if (this.file?.inherited_from_doc_id) {
        return false
      } else if (this.user.tenantLevelRole === 'ADMIN' || this.user.projectLevelRole === 'ADMIN') {
        return true
      } else if (this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKOUT && this.file.checked_out_by !== this.user.userId) {
        return false
      } else if (this.collaborator && !this.file.view_only) {
        if (this.file.state === META_CONFIG.DOC_STATE_MAP.OBSOLETE) {
          return false
        }
        return true
      } else if (this.isOnProjectLevel) {
        return (
          this.user.projectLevelRole === 'ADMIN' ||
          this.user.projectLevelRole === 'COLLABORATOR' ||
          this.user.projectLevelRole === 'EDITOR' ||
          this.isExternalCollaborator
        )
      } else {
        return (
          this.user.tenantLevelRole === 'ADMIN' ||
          this.user.tenantLevelRole === 'COLLABORATOR' ||
          this.user.tenantLevelRole === 'EDITOR' ||
          this.isExternalCollaborator
        )
      }
    },
    showObseleteOption () {
      return this.user.tenantLevelRole === 'ADMIN'
    },
    showUploadRevisionButton () {
      if (this.isInheritedDocument) {
        return false
      }
      if (this.collaborator) {
        return (
          this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKOUT &&
          this.file.checked_out_by === this.user.userId &&
          !this.file.view_only
        )
      } else {
        return (
          this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKOUT &&
      (
        this.user.tenantLevelRole === 'ADMIN' ||
        this.user.tenantLevelRole === 'EDITOR' ||
        this.user.tenantLevelRole === 'COLLABORATOR' ||
        this.user.projectLevelRole === 'EDITOR' ||
        this.isExternalCollaborator
      )
        )
      }
    },
    showDeleteButton () {
      return this.user.tenantLevelRole === 'ADMIN' && this.file.state === META_CONFIG.DOC_STATE_MAP.CHECKOUT && (!this.collaborator || !this.file.view_only)
    },
    showLockButton () {
      return (
        (this.user.tenantLevelRole === 'ADMIN' ||
          this.user.tenantLevelRole === 'COLLABORATOR') &&
        this.file.state !== META_CONFIG.DOC_STATE_MAP.OBSOLETE
      )
    },
    fileVersions () {
      const versions = []
      versions.push({
        created_on: this.file.created_on,
        blob_key: this.file.blob_key,
        version_no: 1,
        doc_name: this.file.doc_name,
        id: this.file.id
      })
      this.file.associated_versions.forEach((version, index) => {
        versions.push({
          created_on: version.created_on,
          blob_key: version.blob_key,
          id: version.id,
          doc_name: version.doc_name,
          version_no: index + 2
        })
      })
      return versions
    },
    getLatestDocId () {
      if (!Array.isArray(this.fileVersions) || this.fileVersions.length === 0) return null
      return this.fileVersions.length > 1 ? this.fileVersions[this.fileVersions.length - 1] : this.fileVersions[0]
    },
    showStatusChangeOptions () {
      return this.showManualCheckinStatusBtn ||
        this.showManualCheckoutStatusBtn ||
        this.showManualLockStatusBtn ||
        this.showManualUndoCheckoutStatusBtn ||
        this.showReleaseStatusBtn ||
        this.showObsoleteStatusBtn
    },
    filteredWorkflowsData () {
      return this.getUserApplicableWorkflows(this.workflowsData)
    }
  },
  methods: {
    handleLifecycleStarted () {
      this.$emit('updated')
    },
    handleWorkflowHistoryUpdate () {
      this.$emit('updated')
    },
    wfAssignees (file) {
      const userIds = new Set()
      const collectUserIds = (users = []) => {
        for (const user of users ?? []) {
          if (user?.user_id) {
            userIds.add(user.user_id)
          }
        }
      }

      // document list payload shape
      collectUserIds(file?.ongoing_lifecycle_workflow?.current_instance_step?.workflow_step?.core_user_group?.core_user_group_members)
      collectUserIds(file?.ongoing_lifecycle_workflow?.current_instance_step?.instance_step_assignees)

      // workflowDataBasedOnInstanceId payload shapes
      collectUserIds(file?.workflow_instances_by_pk?.workflow_stage?.core_user_group?.core_user_group_members)
      collectUserIds(file?.workflow_instances_by_pk?.workflow_instance_steps?.[0]?.instance_step_assignees)
      collectUserIds(file?.workflowDataBasedOnInstanceId?.workflow_instances_by_pk?.workflow_stage?.core_user_group?.core_user_group_members)
      collectUserIds(file?.workflowDataBasedOnInstanceId?.workflow_instances_by_pk?.workflow_instance_steps?.[0]?.instance_step_assignees)
      collectUserIds(file?.workflowDataBasedOnInstanceId?.workflow_stage?.core_user_group?.core_user_group_members)
      collectUserIds(file?.workflowDataBasedOnInstanceId?.workflow_instance_steps?.[0]?.instance_step_assignees)
      collectUserIds(file?.workflow_stage?.core_user_group?.core_user_group_members)
      collectUserIds(file?.workflow_instance_steps?.[0]?.instance_step_assignees)

      return userIds.has(this.user.userId)
    },
    canAccessOngoingWorkflow (file) {
      if (this.user.tenantLevelRole === 'ADMIN' || this.user.projectLevelRole === 'ADMIN') {
        return true
      }
      if (!file?.ongoing_lifecycle_workflow_id) {
        return true
      }
      if (this.isCollaboratorUser || this.isEditorUser) {
        return this.wfAssignees(file)
      }
      return this.wfAssignees(file)
    },
    canCurrentUserStartWorkflow (workflow) {
      if (!this.user?.userId) {
        return false
      }
      return (workflow?.start_steps ?? []).some((step) =>
        step?.user_group?.core_user_group_members?.some((member) => member?.user_id === this.user.userId)
      )
    },
    getUserApplicableWorkflows (workflows) {
      const isEditorOrCollaborator =
        this.collaborator ||
        this.isExternalCollaborator ||
        this.user?.tenantLevelRole === 'EDITOR' ||
        this.user?.tenantLevelRole === 'COLLABORATOR' ||
        this.user?.projectLevelRole === 'EDITOR' ||
        this.user?.projectLevelRole === 'COLLABORATOR'

      if (isEditorOrCollaborator) {
        return workflows ?? []
      }

      return (workflows ?? []).filter((workflow) => this.canCurrentUserStartWorkflow(workflow))
    },
    async onFileHover (file) {
      if (!this.searchKeyword) return
      const id = file.id

      // prevent repeated API calls
      if (this.fileUrls[id]) return

      try {
        const res = await getDocPath(id)
        this.$set(this.fileUrls, id, res.message)
      } catch (e) {
        this.$set(this.fileUrls, id, '') // keep tooltip empty on error
      }
    },
    disable () {
      if (this.disabledisableDownloadButton) {
        return
      }
      this.disabledisableDownloadButton = true
      let token = 'tenant'
      if (this.isOnProjectLevel) {
        token = 'project'
      }
      SwitchDownload(this.file.id, true, token).then(res => {
        this.$emit('updated')
        success(`Download disabled for ${this.file.doc_name}`)
      }).catch(() => {
        alert('Unable to disable download')
      }).finally(() => {
        this.disabledisableDownloadButton = false
      })
    },
    enable () {
      if (this.disableEnableDownloadButton) {
        return
      }
      this.disableEnableDownloadButton = true
      let token = 'tenant'
      if (this.isOnProjectLevel) {
        token = 'project'
      }
      SwitchDownload(this.file.id, false, token).then(res => {
        this.$emit('updated')
        success(`Download enabled for ${this.file.doc_name}`)
      }).catch(() => {
        alert('Unable to enable download')
      }).finally(() => {
        this.disableEnableDownloadButton = false
      })
    },
    enableDownload () {
      if (this.file.view_only && !this.collaborator) return true
      else return false
    },
    disableDownload () {
      if (!this.file.view_only && !this.collaborator) return true
      else return false
    },
    handleRename (newName) {
      if (newName) {
        this.updatedName = newName
      }
      this.editDocModal = false
      this.$emit('updated')
    },
    openUpdateInheritedDocModal () {
      if (!this.isInheritedLatest && this.user.tenantLevelRole !== 'VIEWER') {
        this.updateInheritedDocModal = true
      }
    },
    updateInheritedDoc () {
      let latestDocId
      if (
        this.file.inherited_from_document?.associated_versions?.length !== 0
      ) {
        latestDocId =
          this.file.inherited_from_document?.associated_versions[
            this.file.inherited_from_document?.associated_versions?.length - 1
          ].id
      } else if (
        this.file?.inherited_from_document?.main_version_document
          ?.associated_versions?.length !== 0
      ) {
        latestDocId =
          this.file?.inherited_from_document?.main_version_document
            ?.associated_versions[
            this.file?.inherited_from_document?.main_version_document
              ?.associated_versions?.length - 1
            ].id
      }
      updateInheritedDocument(latestDocId, this.file.id)
        .then(() => {
          this.updateInheritedDocModal = false
          this.$emit('updated-inherited-doc')
          success('Successfully updated document')
        })
        .catch(() => {
          alert('Unable to update document')
        })
    },
    deleteFile (res) {
      if (res) {
        deleteDocument(this.file.id).then((res) => {
          this.$emit('delete')
        })
      }
    },
    async tryDeleteFile () {
      let confirmMessage = 'Are you sure you want to delete this file?'
      if (this.$props.file.material_id) {
        confirmMessage = 'This file is attached to a material. ' + confirmMessage
      } else if (this.isOnProjectLevel) {
        await getAllAttachedDocs().then((res) => {
          this.attachedDocs = res.task_document_association.map((item) => {
            return item
          })
        })
        const Document = this.attachedDocs.find(doc => doc.document_id === this.file.id)
        if (Document) {
          confirmMessage = 'This file is attached to a task. ' + confirmMessage
        }
      }
      confirmationDialog(
        confirmMessage,
        this.deleteFile,
        'Delete',
        'Cancel',
        'Delete File'
      )
    },
    uploadedRevision (payload) {
      this.$emit('uploaded', payload)
    },
    handleStatusChange (file) {
      console.log('file', file.state)
      if (this.isExternalCollaborator) {
        return
      }
      if (file.state === META_CONFIG.DOC_STATE_MAP.CHECKOUT || file.state === META_CONFIG.DOC_STATE_MAP.RELEASE) {
        return
      }
      this.openWorkflowSelectionModal()
    },
    openWFInstanceModal (file) {
      if (!this.file?.ongoing_lifecycle_workflow_id) {
        return
      }
      if (!this.canAccessOngoingWorkflow(file)) {
        return
      }
      this.workflowInstanceModal = true
    },
    openWorkflowSelectionModal () {
      this.wfSelectionModal = true
      this.wfSelectionLoader.skelton = true
      this.selectedManualAction = null
      getWfListBasedOnId({
        documentId: this.file.id,
        category: META_CONFIG.WORKFLOW_SUB_CATE.LIFECYCLE
      })
        .then((res) => {
          this.workflowsData = res.get_applicable_workflows.message ?? []
          this.wfSelectionLoader.skelton = false
        })
        .catch(() => {
          this.workflowsData = []
          this.wfSelectionLoader.skelton = false
        })
    },
    finishWorkflow () {
      this.$refs.WorkflowDetailsPanel.updateWorkflowMaterial(true)
    },
    afterWFAction (closeWFT) {
      if (closeWFT) {
        this.workflowInstanceModal = false
        this.$emit('updated')
      }
    },
    workflowCancelled () {
      this.workflowInstanceModal = false
      this.$emit('updated')
    },
    wfModalLoaderController ({ start = null, stop = null }) {
      if (start) {
        this.wfSelectionLoader.loader = true
      }
      if (stop) {
        this.wfSelectionLoader.loader = false
      }
    },
    setSelectedManualAction (action) {
      this.selectedManualAction = action
    },
    proceedWithManualStatusChange () {
      if (!this.selectedManualAction) {
        return alert('Invalid action selected')
      }
      this.wfSelectionLoader.loader = true
      this.executeManualDocumentAction(this.selectedManualAction)
        .then(() => {
          this.cancelWfSelectionModal()
        })
        .catch(() => {
          this.wfSelectionLoader.loader = false
          alert('Unable to change document status')
        })
    },
    executeManualDocumentAction (action) {
      if (this.isInheritedDocument && ['checkin', 'checkout', 'undo-checkout'].includes(action)) {
        return Promise.reject(new Error('Manual action is disabled for inherited documents'))
      }
      switch (action) {
      case 'checkin':
        return lifeCycleStatusUpdate({ documentId: this.file.id, status: META_CONFIG.DOC_STATE_MAP.CHECKIN }).then(() => {
          this.$emit('updated')
          success('Document checked in successfully')
          addComments('document', this.getLatestDocId.id, 'Document checkedIn', null)
        })
      case 'checkout':
        return lifeCycleStatusUpdate({ documentId: this.file.id, status: META_CONFIG.DOC_STATE_MAP.CHECKOUT }).then(() => {
          this.$emit('updated')
          success('Document checked out successfully')
          addComments('document', this.getLatestDocId.id, 'Document checkedOut', null)
        })
      case 'lock':
        return lifeCycleStatusUpdate({ documentId: this.file.id, status: META_CONFIG.DOC_STATE_MAP.LOCK }).then(() => {
          this.$emit('updated')
          success('Document locked successfully')
          addComments('document', this.getLatestDocId.id, 'Document Locked', null)
        })
      case 'unlock':
        return lifeCycleStatusUpdate({ documentId: this.file.id, status: META_CONFIG.DOC_STATE_MAP.CHECKIN }).then(() => {
          this.$emit('updated')
          success('Document unlocked successfully')
          addComments('document', this.getLatestDocId.id, 'Document Unlocked', null)
        })
      case 'undo-checkout':
        if (this.file.associated_versions.length > 0 && this.file.associated_versions.at(-1).state === META_CONFIG.DOC_STATE_MAP.CHECKOUT) {
          const latestRevisionId = this.file.associated_versions[this.file.associated_versions.length - 1].id
          return deleteDocument(latestRevisionId).then(() => {
            return lifeCycleStatusUpdate({ documentId: this.file.id, status: META_CONFIG.DOC_STATE_MAP.CHECKIN, undoCheckout: true }).then(() => {
              this.$emit('updated')
              success('Document checked out back successfully')
            })
          })
        }
        return lifeCycleStatusUpdate({ documentId: this.file.id, status: META_CONFIG.DOC_STATE_MAP.CHECKIN, undoCheckout: true }).then(() => {
          this.$emit('updated')
          success('Document checked out back successfully')
        })
      case 'obsolete':
        return lifeCycleStatusUpdate({ documentId: this.file.id, status: META_CONFIG.DOC_STATE_MAP.OBSOLETE }).then(() => {
          this.$emit('updated')
          success('Document obseleted successfully')
          addComments('document', this.getLatestDocId.id, 'Document Obseleted', null)
        })
      case 'non obsolete':
        return lifeCycleStatusUpdate({ documentId: this.file.id, status: META_CONFIG.DOC_STATE_MAP.CHECKIN }).then(() => {
          this.$emit('updated')
          success('Document made non obsolete successfully')
          addComments('document', this.getLatestDocId.id, 'Document non obsolete', null)
        })
      case 'release':
        return lifeCycleStatusUpdate({ documentId: this.file.id, status: META_CONFIG.DOC_STATE_MAP.RELEASE }).then(() => {
          this.$emit('updated')
          success('Document released successfully')
          addComments('document', this.getLatestDocId.id, 'Document Released', null)
        })
      default:
        return Promise.reject(new Error('Invalid action selected'))
      }
    },
    cancelWfSelectionModal () {
      this.wfSelectionModal = false
      this.wfSelectionLoader = {}
      this.selectedManualAction = null
      this.workflowsData = []
    },
    openDetail () {
      SendNotificationsForReadingAndDownloadingDocs(this.file.id, 'view')
      this.$emit('openDetail')
    },
    lock () {
      if (this.disableLockButton) {
        return
      }
      this.disableLockButton = true
      setDocumentState(this.file.id, 1, this.user.userId).then((res) => {
        this.$emit('updated')
        success('Document locked successfully')
        addComments('document', this.getLatestDocId.id, 'Document Locked', null)
      }).catch(() => {
        alert('Unable to lock document')
      }).finally(() => {
        this.disableLockButton = false
      })
    },
    unLock () {
      if (this.disableUnlockButton) {
        return
      }
      this.disableUnlockButton = true
      setDocumentState(this.file.id, 2, this.user.userId).then((res) => {
        this.$emit('updated')
        success('Document unlocked successfully')
        addComments('document', this.getLatestDocId.id, 'Document Unlocked', null)
      }).catch(() => {
        alert('Unable to unlock document')
      }).finally(() => {
        this.disableUnlockButton = false
      })
    },
    obselete () {
      if (this.disableObseleteButton) {
        return
      }
      this.disableObseleteButton = true
      setDocumentState(this.file.id, 4, this.user.userId).then((res) => {
        this.$emit('updated')
        success('Document obseleted successfully')
        addComments('document', this.getLatestDocId.id, 'Document Obseleted', null)
      }).catch(() => {
        alert('Unable to obselete document')
      }).finally(() => {
        this.disableObseleteButton = false
      })
    },
    nonObselete () {
      if (this.disableNonObseleteButton) {
        return
      }
      this.disableNonObseleteButton = true
      setDocumentState(this.file.id, 2, this.user.userId).then((res) => {
        this.$emit('updated')
        success('Document made non obsolete successfully')
        addComments('document', this.getLatestDocId.id, 'Document non obsolete', null)
      }).catch(() => {
        alert('Unable to make document non obsolete')
      }).finally(() => {
        this.disableNonObseleteButton = false
      })
    },
    checkin () {
      console.log('getLatestDocId', this.getLatestDocId)
      if (this.disableCheckinButton) {
        return
      }
      this.disableCheckinButton = true
      setDocumentState(this.file.id, 2, this.user.userId).then((res) => {
        this.$emit('updated')
        success('Document checked in successfully')
        addComments('document', this.getLatestDocId.id, 'Document checkedIn', null)
      }).finally(() => {
        this.disableCheckinButton = false
      })
    },
    checkout () {
      if (this.disableCheckoutButton) {
        return
      }
      this.disableCheckoutButton = true
      setDocumentState(this.file.id, 3, this.user.userId).then((res) => {
        this.$emit('updated')
        success('Document checked out successfully')
        addComments('document', this.getLatestDocId.id, 'Document checkedOut', null)
      }).finally(() => {
        this.disableCheckoutButton = false
      })
    },
    undoCheckout () {
      if (this.disableUndoCheckoutButton) {
        return
      }
      this.disableUndoCheckoutButton = true
      lifeCycleStatusUpdate({ documentId: this.file.id, status: META_CONFIG.DOC_STATE_MAP.CHECKIN, undoCheckout: true }).then(() => {
        this.$emit('updated')
        success('Document checked out back successfully')
      }).catch(() => {
        alert('Unable to undo checkout')
      }).finally(() => {
        this.disableUndoCheckoutButton = false
      })

      // if (this.file.associated_versions.length > 0 && this.file.associated_versions.at(-1).state === META_CONFIG.DOC_STATE_MAP.CHECKOUT) {
      //   const latestRevisionId = this.file.associated_versions[this.file.associated_versions.length - 1].id
      //   deleteDocument(latestRevisionId).then(res => {
      //     this.checkin()
      //   }).catch(() => {
      //     alert('Unable to undo checkout')
      //   }).finally(() => {
      //     this.disableUndoCheckoutButton = false
      //   })
      // } else {
      //   setDocumentState(this.file.id, 2, this.user.userId).then((res) => {
      //     this.$emit('updated')
      //     success('Document checked out back successfully')
      //   }).catch(() => {
      //     alert('Unable to undo checkout')
      //   }).finally(() => {
      //     this.disableUndoCheckoutButton = false
      //   })
      // }
    },
    openDownLoadList () {
      if (this.file.inherited_from_doc_id) {
        this.downloadSelectedFile(this.file.inherited_from_document)
        return
      }
      if (this.fileVersions.length === 1) {
        this.downloadSelectedFile(this.fileVersions[0])
        return
      }
      this.openVersionList = true
    },
    downloadSelectedFile (version) {
      SendNotificationsForReadingAndDownloadingDocs(this.file.id, 'download')
      const docName = this.fileVersions[0].doc_name
      this.openVersionList = false
      this.isDownloading = true
      generateS3DownloadingUrlSingle({
        fileName: encodeURIComponent(docName),
        S3Key: version.blob_key
      }).then((resp) => {
        fetch(resp.url)
          .then((res) => {
            return res.blob()
          })
          .then((res) => {
            const blob = new Blob([res])
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = docName
            link.click()
            URL.revokeObjectURL(link.href)
            this.isDownloading = false
          })
          .catch((err) => {
            this.isDownloading = false
            alert(err)
          })
      })
    },
    isDisabledChangeStatus (file) {
      return file.state === META_CONFIG.DOC_STATE_MAP.CHECKOUT || file.state === META_CONFIG.DOC_STATE_MAP.RELEASE
    }
  }
}
</script>

<style lang="scss" scoped>
.file-card {

  .grey-text {
    color: grey;
  }
  .new-tag {
    background: #0f766e;
    color: #fff;
    font-size: var(--text-xs1);
    padding: 2px 6px;
    border-radius: 10px;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  position: relative;
  &--image {
    width: 100%;
    height: 140px;
    background: #dbdbdb;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: center;
    }
  }
  &-footer {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-end;
    gap: 5px;

    .icon-btn {
      width: 26px;
      height: 26px;
      min-width: 26px;
      min-height: 26px;
      flex: 0 0 26px;
      margin-right: 0;
      border-radius: 50%;
      padding: 4px;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;

      &:hover {
        background: #e3e3e3;
      }
    }

    .icon-btn-document {
      width: 26px;
      height: 26px;
      min-width: 26px;
      min-height: 26px;
      flex: 0 0 26px;
      border-radius: 50%;
      padding: 4px;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;

      &:hover {
        background: #e3e3e3;
      }
    }

    img,
    svg {
      width: 16px;
      height: 16px;
    }
  }
  &-action {
    &--btn {
      width: 20px;
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
    }
    &:hover {
      .file-card-options {
        display: block;
      }
    }
  }
  &-options {
    position: absolute;
    top: 40px;
    right: 0;
    width: 140px;
    background-color: var(--white);
    border-radius: 5px;
    padding: 10px 2px;
    filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.3));
    z-index: 1;
    display: none;
    &:before {
      content: "";
      position: absolute;
      top: -10px;
      right: 10px;
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid var(--white);
    }
  }
  &-option {
    display: flex;
    align-items: center;
    padding: 5px 8px;
    cursor: pointer;
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }
    img {
      width: 20px;
      margin-right: 8px;
    }
    span {
      font-size: var(--text-s);
      font-weight: 400;
      line-height: 1;
      color: var(--text-color);
    }
  }
  [data-enable="true"] {
    opacity: 1;
    cursor: pointer;
    pointer-events: auto;
  }
  .chip {
    background: var(--brand-color);
    border-radius: 4px;
    padding: 5px 5px;
    font-size: var(--text-xs1);
    margin-left: 6px;
    line-height: 1;
  }

  .obsolete {
    background: #ff0000;
    color: white;
  }

  .red {
    color: #ff0000;
  }
}
.file-name-card {
  background-color: var(--bg-color);
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 10px;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
  &:hover {
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  }
}
.file-search-tooltip::after {
  content: attr(data-tooltip);
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: 105%;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(223, 220, 220, 0.85);
  color: #060606;
  padding: 6px 8px;
  border-radius: 6px;
  font-size: var(--text-s);
  line-height: 1;
  white-space: nowrap;
  max-width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: opacity 0.18s ease, visibility 0.18s;
  z-index: 50;
}
.file-search-tooltip::before {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: rgba(0,0,0,0.85) transparent transparent transparent;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.18s ease, visibility 0.18s;
  z-index: 50;
}
.file-search-tooltip:hover[data-tooltip]:not([data-tooltip=""])::after,
.file-search-tooltip:hover[data-tooltip]:not([data-tooltip=""])::before {
  visibility: visible;
  opacity: 1;
}

.download-doc-icon {
  position: relative;
  &-list {
    overflow: auto;
    position: absolute;
    background-color: var(--side-bar-color);
    opacity: 1;
    max-height: 200px;
    min-height: fit-content;
    width: 100px;
    right: 0;
    border-radius: 4px;
    list-style: none;
    border: 1px solid rgb(20, 8, 8, 0.2);
    bottom: 25px;
    & li {
      padding: 5px;
      border-bottom: 0.5px solid var(--brand-color);
    }
    & li:hover {
      background-color: var(--brand-color);
    }
    & li:last-child {
      border: none;
    }
  }
}

.wf-status-action {
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
  min-width: 400px;

  &__title {
    margin: 0 0 10px;
    text-transform: uppercase;
    color: #64748b;
    letter-spacing: 0.6px;
    font-size: var(--text-xs2);
    font-weight: 600;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(120px, 1fr));
    gap: 10px;
    width: 100%;
  }

  &__btn {
    width: 100%;
    min-height: 34px;
    border-radius: 7px;
    border: 1px solid #d0d7e2;
    background: #f1f5f9;
    color: #4b5563;
    font-size: var(--text-xs1);
    font-weight: 700;
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  &__btn:hover {
    transform: translateY(-1px);
  }

  &__btn--active {
    border-color: #0f172a;
    background: #0f172a;
    color: #ffffff;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.05);
  }

  &__footer {
    width:100%;
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
  }
}
.is-disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
.material {

  &-history {
      &-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 300px;
& .loader-conatainer{
      min-width: 300px;
    min-height: 300px;
}
  }
  }
}
</style>
